import React from "react";
import "./style.scss";

export default (props) => {

  const handleImg7Click = () => {
    // 跳转到个人中心页面
    window.location.href = '/myCenter';
  };

  return (
    <div className="jixiang-subject-wrapper">
      <img className="img img1" src="https://staticfile.badazhou.com/20250722/053abe55759d4701d32f96f979ea9c0a.jpeg" alt="" />
      <img className="img img2" src="https://staticfile.badazhou.com/20250722/f2b54614640a080cde259f0c9b2418d3.jpeg" alt="" />
      <img className="img img4" src="https://staticfile.badazhou.com/20250722/37807e874af6026f4ba9900f51108e51.jpeg" alt="" />
      <img className="img img5" src="https://staticfile.badazhou.com/20250722/b2842d5235a32a880903aa43381ab461.jpeg" alt="" />
      <img className="img img6" src="https://staticfile.badazhou.com/20250722/8eff309bacf7782f346330f5323e49fe.jpeg" alt="" />
      <img
        className="img img7"
        src="https://staticfile.badazhou.com/20250722/27c50ec7f03ac425e5e83d005a048c56.jpeg"
        alt=""
        onClick={handleImg7Click}
        style={{ cursor: 'pointer' }}
      />
      <img className="img img8" src="https://staticfile.badazhou.com/20250722/32227ac30b99e32551863beea796d444.jpeg" alt="" />
      <img className="img img9" src="https://staticfile.badazhou.com/20250722/83d9e57d1935aa585ed084c59d7000a2.jpeg" alt="" />
    </div>
  );
}